module.exports = __webpack_public_path__ + "static/media/icon-download.009a03db.svg";